<template>
  <div>
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
    <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

    <div v-if="dataLoaded">
        <fiche-container ref="FICHE_CONTAINER"
                         :fiche="selectedFiche"
                         :route="notifRoute"
                         :attribut="attribut"
                         :route-element="routeElement"
                         @back="back"
                         @selectItem="selectItem">
        </fiche-container>
    </div>
    <div v-for="(button, index) in extraButtons" :key="index">
      <loader-button class="ms-2"
                     :outlined="button.outlined"
                     @callback="button.callback()"
                     :label="button.label"
                     :disabled="button.disabled">
      </loader-button>
    </div>
    <section-container :dialogOpen="showWizard"
                       :section="sectionWizard"
                       @closeDialog="hideWizard">
    </section-container>
  </div>
</template>

<script lang="ts">
  import { defineComponent, markRaw, type PropType } from "vue";
  import LoadProgress from '@/framework/base/components/LoadProgress.vue';
  import {
    storeSession,
    storeUser,
    storeAttestation,
    storeNotif,
    storeObjetMetier,
    storePaie,
    storeSupport,
    storeTransaction
  } from '@/generated/stores';
  import { CiRouter } from '@/framework/base/helpers/NavHelper';
  import Route from '@/generated/classes/Route';
  import ModuleBase from '@/framework/base/components/ModuleBase';
  import FicheTestPaiesExtend from '@/extend/fiches/FicheTestPaiesExtend.vue';
  import SectionParametresPaie from '@/custom/sections/SectionParametresPaie.vue';
  import FicheTransactionCaisseExtend from '@/extend/fiches/FicheTransactionCaisseExtend.vue';
  import SectionTransactionCaisse from '@/custom/sections/SectionTransactionCaisse.vue';
  import FicheTransactionSalarieExtend from '@/extend/fiches/FicheTransactionSalarieExtend.vue';
  import SectionTransactionSalarieExtend from '@/extend/sections/SectionTransactionSalarieExtend.vue';
  import FicheTransactionEtablissementExtend from '@/extend/fiches/FicheTransactionEtablissementExtend.vue';
  import SectionTransactionEtablissementExtend from '@/extend/sections/SectionTransactionEtablissementExtend.vue';
  import FicheVersementEmployeurExtend from '@/extend/fiches/FicheVersementEmployeurExtend.vue';
  import SectionVersementEmployeur from '@/custom/sections/SectionVersementEmployeur.vue';
  import FicheGestionAemExtend from '@/extend/fiches/FicheGestionAemExtend.vue';
  import SectionGestionAem from '@/custom/sections/SectionGestionAem.vue';
  import FicheAttestationCompteExtend from '@/extend/fiches/FicheAttestationCompteExtend.vue';
  import SectionAttestationCompte from '@/custom/sections/SectionAttestationCompte.vue';
  import FicheObjetMetierExtend from '@/extend/fiches/FicheObjetMetierExtend.vue';
  import SectionObjetMetierListExtend from '@/extend/sections/SectionObjetMetierListExtend.vue';
  import { Fiches, Modules, Sections } from '@/generated/classes/AppSchema';
  import { GenModule, RessourceGenModule } from '@/generated/ressources/generatedRessources';
  import Wizard from '@/extend/classes/Wizard';
  import Section from '@/framework/base/classes/Section';
  import SectionWizard from '@/framework/wizard/components/SectionWizard.vue';
  import Fiche from '@/framework/base/classes/Fiche';
  import { RouteElements } from '@/framework/base/classes/Section';
  import User from '@/generated/classes/User';
  import FicheContainerAbstract from "@/framework/base/components/FicheContainerAbstract.vue";

  export function ModuleSupportOpenFiche(route: Route | undefined): RouteElements {
    const section = new Section();
    const fiche = new Fiche();
    if (route && route.fiche) {
      switch (route.fiche) {
        case Fiches.TEST_PAIES: {
          fiche.component = FicheTestPaiesExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.TRANSACTION_CAISSE: {
          fiche.component = FicheTransactionCaisseExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.TRANSACTION_SALARIE: {
          fiche.component = FicheTransactionSalarieExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.TRANSACTION_ETABLISSEMENT: {
          fiche.component = FicheTransactionEtablissementExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.VERSEMENT_EMPLOYEUR: {
          fiche.component = FicheVersementEmployeurExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.GESTION_AEM: {
          fiche.component = FicheGestionAemExtend;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.ATTESTATION_COMPTE: {
          fiche.component = FicheAttestationCompteExtend;
          fiche.type = 'attestation'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeAttestation.createNewAttestation();
            } else {
              fiche.data = storeAttestation.getAttestation(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.OBJET_METIER: {
          fiche.component = FicheObjetMetierExtend;
          fiche.type = 'objetMetier'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeObjetMetier.createNewObjetMetier();
            } else {
              fiche.data = storeObjetMetier.getObjetMetier(route.ficheObjId);
            }
          }
          break;
        }
        case Fiches.CONTAINER: {
          fiche.component = FicheContainerAbstract;
          fiche.type = 'support'
          if (route && route.ficheObjId != null) {
            if (route.ficheObjId == 0) {
              fiche.data = storeSupport.createNewSupport();
            } else {
              fiche.data = storeSupport.getSupport(route.ficheObjId);
            }
          }
          break;
        }
      }
    } else {
      fiche.component = FicheAttestationCompteExtend;
      fiche.type = 'attestation'
      if (route && route.ficheObjId != null) {
        if (route.ficheObjId == 0) {
          fiche.data = storeAttestation.createNewAttestation();
        } else {
          fiche.data = storeAttestation.getAttestation(route.ficheObjId);
        }
      }
    }
    if (route && route.section && route.section != Sections.NONE) {
      switch (route.section) {
        case Sections.PARAMETRES_PAIE: {
          section.component = SectionParametresPaie;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.TRANSACTION_CAISSE: {
          section.component = SectionTransactionCaisse;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.TRANSACTION_SALARIE: {
          section.component = SectionTransactionSalarieExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.TRANSACTION_ETABLISSEMENT: {
          section.component = SectionTransactionEtablissementExtend;
          section.type = 'transaction'
          if (route.sectionObjId == 0) {
            section.data = storeTransaction.createNewTransaction();
          } else {
            section.data = storeTransaction.getTransaction(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.VERSEMENT_EMPLOYEUR: {
          section.component = SectionVersementEmployeur;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.GESTION_AEM: {
          section.component = SectionGestionAem;
          section.type = 'support'
          if (route.sectionObjId == 0) {
            section.data = storeSupport.createNewSupport();
          } else {
            section.data = storeSupport.getSupport(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.ATTESTATION_COMPTE: {
          section.component = SectionAttestationCompte;
          section.type = 'attestation'
          if (route.sectionObjId == 0) {
            section.data = storeAttestation.createNewAttestation();
          } else {
            section.data = storeAttestation.getAttestation(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
        case Sections.OBJET_METIER_LIST: {
          section.component = SectionObjetMetierListExtend;
          section.type = 'objetMetier'
          if (route.sectionObjId == 0) {
            section.data = storeObjetMetier.createNewObjetMetier();
          } else {
            section.data = storeObjetMetier.getObjetMetier(route.sectionObjId);
          }
          section.showButton = true;
          break;
        }
      }
    }
    if (fiche && fiche.component) {
      fiche.component = markRaw(fiche.component);
    }
    if (section && section.component) {
      section.component = markRaw(section.component);
    }
    const res = new RouteElements();
    res.fiche = fiche;
    res.section = section;
    return res;
  }

  export default defineComponent({
    extends: ModuleBase,
    components: {
      LoadProgress,
    },

    props: {
    },

    created (): void {
      if (this.route) {
        this.notifRoute = this.route;
      }
      const session = storeSession.connectedUser;
      if (session) {
        const user = storeUser.getUser(session.id);
        if (user.modules.includes(Modules.SUPPORT)) {
          this.wizardDone = true;
        }
      }
      if (!this.wizardDone) {
        Wizard.showWizard(Modules.SUPPORT).then((res) => {
          if (res.id > 0) {
            this.wizard = res;
            this.showWizard = true;
          } else {
            User.acceptCgu(true);
            this.wizardDone = true;
          }
        })
      }
      this.loadStores();
    },

    data() {
      const attribut: unknown = undefined;
      const route = CiRouter.getRoute();
      return {
        wizard: new Wizard(),
        attribut,
        notifRoute: new Route(),
        route,
      }
    },

    computed: {
      ressource () {
        return RessourceGenModule(GenModule.MODULE_SUPPORT);
      },
      sectionWizard (): Section {
        const section = new Section();
        section.component = SectionWizard;
        section.data = this.wizard;
        section.helper = true;
        return section;
      },

      storesLoaded (): boolean {
        return true;
      },

      dataLoaded (): boolean {
        const res = this.wizardDone && this.storesLoaded
        if (res && this.init) {
          this.setInit(false);
          if (!this.route) {
            this.selectItem(this.route);
          }
          CiRouter.setRouteChangedSelector(this.routeChanged);
        }
        return res;
      }
    },

    methods: {
      loadStores() : void{
        // Load and register events on used server classes
        storeAttestation.registerAttestation();
        storeNotif.registerNotif();
        storeObjetMetier.registerObjetMetier();
        storePaie.registerPaie();
        storeSupport.registerSupport();
        storeTransaction.registerTransaction();
      },
      setInit(value: boolean) : void{
        this.init = value;
      },
      routeChanged (route: Route): void {
        this.selectItem(route);
      },
      selectItem(route: Route | undefined): void {
        const routeElement = ModuleSupportOpenFiche(route);
        this.routeElement = routeElement;
        this.selectedFiche = routeElement.fiche;
        this.selectedFiche.ressourceHeader = this.ressource;
        if (route) {
          this.notifRoute = route;
          if (route && route.attribut) {
            this.attribut = route.attribut;
          } else {
            this.attribut = undefined;
          }
          if (route.section && route.section != Sections.NONE) {
            this.lastShowSection = !this.lastShowSection;
            this.selectedFiche.showSection = this.lastShowSection;
          }
        }
        const index = this.lastSelectedFiche.findIndex(item => {
          return item.component === this.selectedFiche.component;
        })
        if (index >= 0) {
          this.lastRoutes.splice(index + 1)
          this.lastSelectedFiche.splice(index + 1)
        } else {
          this.lastRoutes.push(route);
          this.lastSelectedFiche.push(this.selectedFiche);
        }
      }
    }
  })
</script>
